import { useState, useEffect, useRef } from "react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
export default function StepsAndCopings() {
  const sectionRef = useRef<HTMLElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setVisible(true);
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);
  const products = [{
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1653984/img/4.webp",
    alt: "Bullnose Steps",
    title: "Bullnose Steps",
    desc: "Available in a range of materials incuding stone and porcelain.",
    delay: "delay-100"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1653984/img/landform-_29_.webp",
    alt: "Coping Stones",
    title: "Coping Stones",
    desc: "Add a stylish finish to walls with off the shelf and bespoke coping stones",
    delay: "delay-200"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1653984/img/_PH_0750.webp",
    alt: "Go Bespoke",
    title: "Go Bespoke",
    desc: "Bring your ideas to life with bespoke stone and porcelain crafted at our in-house factory.",
    delay: "delay-300"
  }];
  return;
}